<template lang="pug">
collapse-component.conteudo(title='Filtrar processos')
    .linha
        .coluna-3
            text-input-component(v-model='filtro.car', label='Número de registro no CAR')
        .coluna-3
            text-input-component(v-model='filtro.nomeImovel', label='Nome do imóvel')
    .linha(style="align-items: flex-start")
        .coluna-3
            text-input-component(v-model='filtro.cpfCnpjProprietario', label='CPF/CNPJ')
        .coluna-3
            date-picker-component(v-model='filtro.dataEnvioDe', label='Data inicial da Assinatura Termo')
        .coluna-3
            date-picker-component(v-model='filtro.dataEnvioAte', label='Data final da Assinatura Termo')

    .linha(style="align-items: flex-start")
        .coluna-2
            text-input-component(:disabled='true', v-model='filtro.uf', label='UF')
        .coluna-3
            select-filter-component(
                v-if="mostrarRegional"
                ref='selectRegional'
                :list='regionais'
                label='nome'
                fieldLabel='Regional:'
                placeholder='Selecione'
                :filterable='true'
                @change='selecionarRegional'
            )
        .coluna-3
            select-filter-component(
                ref='selectMunicipio'
                :list='municipios'
                label='nome'
                fieldLabel='Município:'
                placeholder='Selecione'
                :filterable='true'
                @change='selecionarMunicipio'
            )
    .linha(style="align-items: flex-start")
        .coluna-2
            select-filter-component(
                ref='selectCondicao'
                :list='condicoes'
                label='nome',
                key='nome',
                fieldLabel='Condição:'
                placeholder='Selecione'
                :filterable='true'
                @change='selecionarCondicao'
            )
        .coluna-3
            select-filter-component(
                v-if="mostrarFaseProcesso"
                ref='selectCondicaoInscricao'
                :list='condicoesInscricao'
                key='id',
                label='label'
                fieldLabel='Fase do Processo:'
                placeholder='Selecione'
                :filterable='true'
                @change='selecionarCondicaoInscricao'
            )
    .linha.justify-end
        .coluna-1
            button-component(
                label='Limpar',
                icon='mdi-trash-can',
                background-color='#ddd',
                color='#666',
                @click.native='limpar'
            )
        .coluna-1
            button-component(label='Pesquisar', icon='mdi-magnify', @click.native='pesquisar')
</template>

<script>
import { CondicaoEnum, CondicaoInscricaoEnum, ListaCondicoes } from '@/enums/processo.enum.js';
import { Perfil } from '@/utils/constants.utils.js';

export default {
    name: 'FiltroComponent',
    props: {
        municipios: {
            type: Array,
            required: true,
        },
        mostrarFaseProcesso: {
            type: Boolean,
            default: false
        },
        mostrarRegional: {
            type: Boolean,
            default: false
        },
        regionais: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            filtro: {
                uf: 'SP',
                pagina: 1,
                quantidadePagina: 10,
            },
            CondicaoEnum,
            condicoes: [],
            CondicaoInscricaoEnum,
            condicoesInscricao: []
        };
    },
    watch: {
        '$route.meta.titulo'() {
            this.filtrarCondicoes();
            this.filtrarCondicoesInscricao();
        }
    },

    mounted() {
        this.filtrarCondicoes();
        this.filtrarCondicoesInscricao();
    },

    methods: {
        filtrarCondicoes() {
            this.limpar();
            let codigoPagina = this.$route.meta.codigo;
            const usuario = this.$eu();
            if(usuario.perfil === Perfil.GERENTE_OPERACIONAL && codigoPagina === 'CONSULTAR_PROCESSOS'){
                codigoPagina = codigoPagina  + '_GO';
            }
            this.condicoes = ListaCondicoes[codigoPagina];
        },
        filtrarCondicoesInscricao(){
            this.condicoesInscricao = Object.values(CondicaoInscricaoEnum);
        },
        limpar() {
            this.filtro = {
                uf: 'SP',
                pagina: 1,
                quantidadePagina: 10,
            };
            
            this.$refs.selectCondicao.itemSelecionado = '';
            this.$refs.selectMunicipio.itemSelecionado = '';
            this.$refs.selectRegional.itemSelecionado = '';
            
            if (this.mostrarRegional && this.$refs.selectRegional) {
                this.$refs.selectRegional.itemSelecionado = '';
            }

            if (this.mostrarFaseProcesso && this.$refs.selectCondicaoInscricao) {
                this.$refs.selectCondicaoInscricao.itemSelecionado = '';
            }

            this.$emit('filtro:limpar', this.filtro);
        },
        pesquisar() {
            this.$emit('filtro:pesquisar', this.filtro);
        },
        selecionarCondicao(condicao) {
            this.filtro.condicao = condicao;
        },
        selecionarCondicaoInscricao(condicaoInscricao) {
            this.filtro.condicaoInscricao = condicaoInscricao;
        },
        selecionarMunicipio(municipio) {
            this.filtro.municipio = municipio ? (municipio.nome || municipio) : null;
            if (this.mostrarRegional) {
                this.$emit('municipio:alterado', municipio);
            }
        },
        selecionarRegional(regional) {
            this.filtro.regional = regional;
            if (this.mostrarRegional) {
                this.$emit('regional:alterada', regional);
            }
        }
    },
};
</script>
